import React, { Component } from 'react';
import { ApolloConsumer  } from "react-apollo";
import { getItemMedasByFilter } from '../../graphqlDic';
import { Link } from 'react-router-dom';
import MoviesMediaUI  from '../CommonComponents/MoviesMediaUI';

class FilterItemMediasComponent extends Component {

    constructor(props) {
        super(props);

        let { medias } = props.dataFilter;
        let { endCursor } = props.dataFilter.pageInfo;
        let { totalCount } = props.dataFilter;
        let toggleBtnViewMore = medias.length < totalCount ? true : false;

        this.state = {
            medias,
            toggleBtnViewMore,
            endCursor
        }
    }
    
    componentWillReceiveProps(nextProps) {
        let { medias } = nextProps.dataFilter;
        let { totalCount } = nextProps.dataFilter;
        let { endCursor } = nextProps.dataFilter.pageInfo;
        let toggleBtnViewMore = medias.length < totalCount ? true : false;
        this.setState({
            medias,
            toggleBtnViewMore,
            endCursor
        });
    }
      
    componentDidUpdate() {
        this.scrollToBottom();
    }

    scrollToBottom = () => {
        this.contentMovies.scrollIntoView({ block: "end", behavior: "smooth" });
    }

    onViewMore = data => {
        let { medias } = this.state;
        let { totalCount } = this.props.dataFilter;
        let { endCursor } = data.getItemMedasByFilter.pageInfo;
        let resolveData = data.getItemMedasByFilter.medias;
        
        if (resolveData.length) {
            let result = medias.concat(resolveData);
            let toggleBtnViewMore = result.length < totalCount ? true : false;
            this.setState({
                medias: result,
                endCursor,
                toggleBtnViewMore
            });
        }
    }

    showMedias = () => {
        let result = [];
        let { medias } = this.state;

        if (medias.length) {
            result = medias.map((media, index) => {
                return (
                    <Link to={ '/media/watch/' + media.id } key={ index } >
                        <MoviesMediaUI dataMedias={ media } />
                    </Link>   
                );
            });
        }
        return result.length ? result : <span className="text-center center-block">Không có phim nào trong danh sách</span>;
    }

    render() {
        let paramsUrl = {...this.props.getParamUrl, after: this.state.endCursor};
        let { toggleBtnViewMore } = this.state;
        
        return (
            <div className="movie-euro" ref={(el) => { this.contentMovies = el; }}>
                <div className="container">
                    <div className="main clearfix">
                        { this.showMedias() }
                    </div>
                </div>
                
                { toggleBtnViewMore ?
                 <ApolloConsumer>
                 { client => (
                     <button 
                         type="button" 
                         className="center-block btn btn-primary"
                         onClick={ async (e) => {
                             let btnViewMore = e.target;
                             btnViewMore.disabled = true;
                             this.watingViewMore.style.display = 'inline-block';
                             
                             const { data } = await client.query({
                                 query: getItemMedasByFilter,
                                 variables: paramsUrl
                             });

                             btnViewMore.disabled = false;
                             this.watingViewMore.style.display = 'none';
                             this.onViewMore(data);
                         }}
                     > 
                     <i 
                         className="fa fa-refresh fa-spin" 
                         style={{display: 'none'}}
                         ref={(el) => { this.watingViewMore = el; }}
                     ></i> Xem thêm...
                     </button>
                 ) }
                </ApolloConsumer>
                : null
                }
                
            </div>
        );
    }

}

export default FilterItemMediasComponent;



// WEBPACK FOOTER //
// ./src/components/MoviePageComponent/FilterItemMediasComponent.js